import React, { useEffect, useState } from 'react';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { listen, unlistenByKey } from 'ol/events';
import PropTypes from 'prop-types';

// Inspired from https://github.com/openlayers/openlayers/blob/main/src/ol/control/FullScreen.js
const EVENTS = ['fullscreenchange', 'webkitfullscreenchange', 'MSFullscreenChange'];

function docIsFullScreen() {
  return !!(document['webkitIsFullScreen'] || document['msFullscreenElement'] || document.fullscreenElement);
}

function requestFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element['msRequestFullscreen']) {
    element['msRequestFullscreen']();
  } else if (element['webkitRequestFullscreen']) {
    element['webkitRequestFullscreen']();
  }
}

function exitFullScreen() {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  } else if (document['msExitFullscreen']) {
    return document['msExitFullscreen']();
  } else if (document['webkitExitFullscreen']) {
    return document['webkitExitFullscreen']();
  }
}

export default function FullScreen({ map }) {
  const [isFullScreen, setIsFullScreen] = useState(docIsFullScreen());

  const element = map.getTargetElement().parentNode;

  const onClick = () => {
    isFullScreen ? exitFullScreen() : requestFullScreen(element);
  };

  const onFullScreenChange = () => setIsFullScreen(docIsFullScreen);

  useEffect(() => {
    const keys = EVENTS.map((event) => listen(document, event, onFullScreenChange));
    return () => keys.map((key) => unlistenByKey(key));
  });

  return (
    <Paper elevation={4} sx={{ p: '2px' }}>
      <IconButton
        color="primary"
        aria-label="full-screen"
        title={isFullScreen ? 'Quitter le plein écran' : 'Plein écran'}
        onClick={onClick}
      >
        {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Paper>
  );
}

FullScreen.propTypes = {
  map: PropTypes.object.isRequired,
};
